var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Section',{staticClass:"plain-image",attrs:{"width":_vm.sectionWidth}},[_c('prismic-image',{attrs:{"img":_vm.slice.primary.image,"w":_vm.imageWidth}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }